module.exports = __webpack_public_path__ + "resources/img/facetec-ui-customizations-14.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-customizations-14.png
// module id = 1389
// module chunks = 0